/*
 * fn: getManaCurveData
 *
 * Gets data for Mana Curve graphs
 *
 */
import { type PageType } from '@/defs/page'

type Props = {
  manaCurve?: NonNullable<PageType['charts']>['manaCurve']
}

export const getManaCurveData = ({ manaCurve = {} }: Props) =>
  Object.keys(manaCurve).map((k) => ({ count: manaCurve[k], name: k }))
